import { tokens } from "../../tokens";
import {
  StyleProp,
  StyleSheet,
  Text as RnText,
  type TextProps as RnTextProps,
  type TextStyle as RnTextStyle,
} from "react-native";

type TextWeight = "normal" | "semibold" | "bold";

export type TextProps = Omit<RnTextProps, "style"> & {
  style?: StyleProp<Omit<RnTextStyle, "fontWeight" | "fontFamily">>;
  weight?: TextWeight;
};

export function Text({ weight = "normal", ...props }: TextProps) {
  return <RnText {...props} style={[textStyles.baseline, textStyles[weight], props.style]} />;
}

const textStyles = StyleSheet.create({
  baseline: {
    color: tokens.colors.$houseDark,
  },
  normal: {
    fontFamily: "Montserrat",
  },
  semibold: {
    fontFamily: "MontserratSemiBold",
  },
  bold: {
    fontFamily: "MontserratBold",
  },
});
